const BASE_URL = 'https://viacep.com.br/ws';

export interface AddressInfo {
  street: string;
  neighborhood: string;
  city: string;
  state: string;
  postalCode: string;
  ibgeCode: string;
}

export const fetchAddressByCep = async (
  cep: string
): Promise<AddressInfo | null> => {
  const res = await fetch(`${BASE_URL}/${cep}/json`);
  const data = await res.json();

  if (data.erro) {
    return null;
  }

  return {
    street: data.logradouro,
    neighborhood: data.bairro,
    city: data.localidade,
    state: data.uf,
    postalCode: data.cep,
    ibgeCode: data.ibge
  };
};
